import React, {useState, useEffect} from "react";
import ExploreMasonry from "./ExploreMasonry";
import "./ShowEndImageSection.css"
import { Link, useNavigate } from "react-router-dom";
import "./Home.css"
// import  RelatedInterests  from "./RelatedInterests";


export function ShowEndImageSection (props){
const [featuredStoredImage, setFeatureStoredImage] = useState([]);
const [lastUpdatedTime, setLastupdatedTime] = useState(null);
const [suggestedState, setSuggestedState] = useState(null);
const navigate = useNavigate();
const [initialLoadedImageses, setInitailoadedImages] = useState([])   



return(
  <>
  {/* container app_container */}
  {/* <div className={ props.componentFrom === "blog-detail" ? "blog_explore_section p-0" : "container blog_explore_section p-0 text-to-bold-container"}> */}
<div className={`app_container container blog_explore_section p-0 ${props.componentFrom !== "blog-detail" ? 'text-to-bold-container' :''} ${props.componentFrom === "exploreNext" ? 'small_padding_for_explorenext_desktop max-width-full' : ''}`}>

    {props.componentFrom !== "exploreNext" && <div className="blog_detail_divider"></div>}

<div className="explore_blog_heading d-flex justify-content-between align-items-center highlight_explore_images_heading">

<div className="d-flex flex-column">
  {/* <h2 className="app_home_feeds_heading desktop_heading">Discover more inspiration</h2> */}
  <h2 className="app_home_feeds_heading desktop_heading m-0">{props.componentFrom !== "exploreNext" ? 'Discover more inspiration' : 'Trending Today'}</h2>
   <div className={`app_home_feeds_heading short_mobile_heading m-0`}>{props.componentFrom !== "exploreNext" ? 'Discover more inspiration' : 'Trending Today'}</div>
  <ShowTitleOnHeading componentFrom={props.componentFrom} lastUpdatedTime={lastUpdatedTime}/>
  

</div>
<Link className="app_explore_see_all cursor-pointer"
          
         
           to={"/explore"}
           draggable={false} 
            //  onMouseDown={(e)=>sendClickFeed(e)} 
            //  onMouseUp={(e)=>removeClickFeed(e)} 
            //  onMouseOut={(e)=>orignalElement(e)}
            // onTouchStart={(e) => sendClickFeed(e)}
            // onTouchEnd={(e) => removeClickFeed(e)}
            // onTouchCancel={(e) => orignalElement(e)}
          
          >
          {/* {props.forWhich === "personalized" ? <ButtonText /> : "See all"} <i className="fa-solid fa-angle-right home_seeall_icon"></i> */}
          See all
<i className="fa-solid fa-angle-right home_seeall_icon"></i>
          </Link>
</div>
  {/* <ExploreMasonry componentFrom="home" displayFor="forExplore" featurStoredImage={setFeatureStoredImage} lastUpdatedAt={setLastupdatedTime} 
   setCurrentObj={setSuggestedState} suggestedObjectClickedValue={suggestedState} 
   instantLoadForExplore={setInitailoadedImages}
   fetchSavedImages={props.fetchSavedImages} 
    /> */}
  <ExploreMasonry
  componentFrom="home"
  displayFor="forExplore"
  showEnd={"yes"}
  featurStoredImage={setFeatureStoredImage}
  lastUpdatedAt={setLastupdatedTime}
  setCurrentObj={setSuggestedState}
  suggestedObjectClickedValue={suggestedState}
  fetchSavedImages={props.fetchSavedImages} 
  instantLoadForExplore={setInitailoadedImages}
/>

</div>

 <div className={props.componentFrom !== "exploreNext" ? 'd-flex justify-content-center align-items-center my-4' : 'd-flex justify-content-center align-items-center mt-3 mb-1'} >

    <button className="brand_button image_ending_section" tabIndex={0} onClick={(e)=> navigate("/explore")}   
    initialImages={initialLoadedImageses}  
    buttonType="explore"
    
     style={{color: "white", width: "fit-content", padding: "10px 30px 14px 30px", cursor: "pointer", borderRadius: "10px", fontWeight: 600,
      pointerEvents: "auto",
     }}> <span className='brand_button_text'> {props.componentFrom === "exploreNext" ? 'Go to explore' : 'Continue exploring'} </span><i className="fa-solid fa-angles-right icon_space"></i></button>
    </div>

     {/* {featuredStoredImage.length > 0 && (
  <RelatedInterests
    // tag={featuredStoredImage[0]?.tags?.split(",")[0]?.trim().toLowerCase()}
    tag={"sunset"}
  />
)} */}

  </>
)

  
}

function ShowTitleOnHeading(props){
    let text = "";

    

  if (props.componentFrom === "text-to-bold" ) {
    text = "Explore images & get ready-to-use captions";
    
    // text =  window.innerWidth > 580 ? "Click any images to see similar & get ready-to-use captions" : "Tap any images to see similar & get ready-to-use captions";
    
  } 
  else if (props.componentFrom === "exploreNext"){
    // text = "Click any image to see similar images";
    text = "Images updated every hour";

  }
  else {
    text =
      window.innerWidth > 580
        ? "Explore and download images while listening blogs"
        : "Tap any images to see more similar";
  }


  function getLastUpdatedText(lastUpdatedTime) {
  // 0–15 min → Updated just now 🔥
  if (lastUpdatedTime >= 0 && lastUpdatedTime <= 15) {
    return "Updated just now";
  }

  // 45–59 min → Just updating in — X min left ⏳
  if (lastUpdatedTime >= 45 && lastUpdatedTime <= 59) {
    return `New images arriving in ${60 - lastUpdatedTime} min`;
  }

  // Everything else → Last updated at X min ago
  return `Last updated ${lastUpdatedTime} min ago`;
}


    return(
        <>
{/* <span className="last_updated_text mt-1">{window.innerWidth > 580 ? 'Explore images while listening'  : 'Discover images you might like'}</span> */}
{/* <span className="last_updated_text mt-1">{text}</span> */}
{/* <span className="last_updated_text mt-1">{"Discover new images every hour"}</span> */}
<span className="last_updated_text mt-1">{getLastUpdatedText(props.lastUpdatedTime)}</span>
        </>
    )
}



